import request from './request.js';
import {requestbody} from './request.js'

export async function selectRoles(params = {

}) {
    return await request('/sys/selectRoles', 'post', params)
}
export async function createRole(params = {

}) {
    return await requestbody('/system/role/createRole', 'post', params)
}


export async function selectUsers(params = {

}) {
    return await requestbody('/sys/selectUsers', 'post', params)
}
export async function deletes(params = {

}) {
    return await request('/system/role/delete', 'post', params)
}

export async function selectNotGlUsers(params = {

}) {
    return await requestbody('/sys/selectNotGlUsers', 'post', params)
}
export async function saveRoleUser(params = {

}) {
    return await requestbody('/system/role/saveRoleUser', 'post', params)
}
export async function ResourceTableList(params = {

}) {
    return await requestbody('/system/resources/getResourceTreeTableList', 'get', params)
}

export async function TreeListByRoleId(params = {

}) {
    return await requestbody('/system/resources/getResourceTreeListByRoleId', 'get', params)
}
export async function saveAuthResource(params = {

}) {
    return await requestbody('/system/role/saveAuthResource', 'post', params)
}

export async function DeptTreeTableList(params = {

}) {
    return await requestbody('/system/dept/getDeptTreeTableList', 'get', params)
}
export async function ScopeDeptIds(params = {

}) {
    return await requestbody('/system/role/getDataScopeDeptIdsByRoleId', 'get', params)
}

export async function rolesave(params = {

}) {
    return await requestbody('/system/role/save', 'post', params)
}

export async function copyRole(params = {}) {
    return await requestbody('/system/role/copy', 'post', params)
}

export async function selectTaskData(params = {

}) {
    return await requestbody('/sys/selectTaskData', 'post', params)
}

export async function sendExportRole(params = {

}) {
    return await requestbody('/sys/sendExportRole', 'post', params)
}